import React from 'react'

export default function Label({ name, label, error }) {
  return (
    <span
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingRight: '10px',
      }}
    >
      {label}
      <span style={{ color: 'red', fontSize: '10px' }}>
        {error[name]?.message}
      </span>
    </span>
  )
}
